import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {
  ContentPopper,
  ContentPopperProps,
  DrawerBody,
  ModalHeader,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useIsAuthenticated} from '../../../features/Authentication/hooks/useIsAuthenticated';
import {useIsCoinsActive} from '../../../features/Coins/utils/useIsCoinsActive';
import {CouponWallet} from '../../../features/Coupons/CouponWallet/deprecated/CouponWallet';
import {useActiveTab} from '../utils/useActiveTab';
import {useTrackWalletContentView} from '../utils/useTrackWalletContentView';
import {useWallet} from '../utils/useWallet';
import {WalletContent} from './WalletContent/WalletContent';

interface WalletProps {
  ContentPopperLayoutComponent: ContentPopperProps['LayoutComponent'];
  setSelectedProduct?: (product: Product | undefined) => void;
}

export const Wallet: React.FC<WalletProps> = ({
  ContentPopperLayoutComponent,
  setSelectedProduct,
}) => {
  useTrackWalletContentView();
  const isCoinsActive = useIsCoinsActive();
  const {activeTab, onTabClick, walletContentRef} = useActiveTab();
  const {isOpen, handleOnClose} = useWallet();

  const isCoinsTabOpened = isCoinsActive && activeTab === 'coins' && isOpen;
  const {isAuthenticated} = useIsAuthenticated();

  if (!isCoinsActive) {
    // This is the old CouponWallet, needs to be removed once the coins can be released
    return (
      <CouponWallet
        ContentPopperLayoutComponent={ContentPopperLayoutComponent}
        setSelectedProduct={setSelectedProduct}
      />
    );
  }

  if (isCoinsTabOpened && !isAuthenticated) {
    return null;
  }

  return (
    <StyledContentPopper
      data-testid="wallet"
      LayoutComponent={ContentPopperLayoutComponent}
      onClose={handleOnClose}
      hideCloseButton
      slideDirection="left"
      renderInPortal
      open={isOpen}
      animated
      preventSlideUpAnimation
      bodyContent={
        <WalletContent
          ref={walletContentRef}
          activeTab={activeTab}
          onTabClick={onTabClick}
          setSelectedProduct={setSelectedProduct}
          ContentPopperLayoutComponent={ContentPopperLayoutComponent}
        />
      }
    />
  );
};

const StyledContentPopper = styled(ContentPopper)<{
  $isHighTierCouponsActive?: boolean;
  animated: boolean;
}>`
  ${DrawerBody} {
    padding: 0;
  }

  ${ModalHeader} {
    display: none;
  }

  overflow: auto;
`;
